import React  from 'react'
import styled from 'styled-components'
import { inheritPrimaryColor } from '../colors'
import { Link } from 'react-router-dom'

const MemberSummary = styled(({ name, slug, jobTitle, picture, hideText, ...props }) => {
  return (
    <Link to={`/team/${slug}`} {...props}>
      <ProfilePicContainer src={picture} />
      {!hideText && <Name>{name}</Name>}
      {!hideText && <Title>{jobTitle}</Title>}
    </Link>
  )
})`
  margin: 40px;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  width: 250px;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.05)
  }
`

const ProfilePicContainer = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  border: 8px solid ${inheritPrimaryColor};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('${p => p.src}');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  ${MemberSummary}:hover &:after {
    content: "";
    background-color: ${inheritPrimaryColor};
    opacity: 0.35;
    z-index: 100;
    position: absolute;
    border-radius: 50%;
    right: 0px;
    top: 0px;
    bottom: 0px;
    left: 0px;
  }
`

const Name = styled.div`
  text-align: center;
  color: ${inheritPrimaryColor};
  font-weight: 500;
  font-size: 1.2em;
  margin: 12px 0px 8px;
`

const Title = styled.div`
  text-align: center;
  color: rgb(150, 150, 150);
`

export default MemberSummary